import MagicButtonIcon from 'assets/icons/magic-button.svg';
//

const ChatHeader = () => {
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex items-center justify-between gap-2'>
        <div className='flex items-center gap-2'>
          <img src={MagicButtonIcon} alt='AI' className='w-7 h-7' />
          <h2 className='text-[28px] dark:text-white'>Ask Compass</h2>
        </div>
      </div>

      <p className='text-base text-gray-700 dark:text-gray-300'>
        Get instant insights and answers about your business growth metrics and
        performance data.
      </p>
    </div>
  );
};

export default ChatHeader;
